import { render, staticRenderFns } from "./ShipmentView.vue?vue&type=template&id=e1d3b31c&scoped=true&"
import script from "./ShipmentView.vue?vue&type=script&lang=js&"
export * from "./ShipmentView.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentView.vue?vue&type=style&index=0&id=e1d3b31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d3b31c",
  null
  
)

export default component.exports